import angular from 'angular';
import '@common/itemCard/itemCard.module';

angular.module('eCareVault.common.itemBoard', [
    'eCareVault.common.itemCard',
]);
